// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FixedBottom_wrapper__1P-rh","wrapper--hided":"FixedBottom_wrapper--hided__2fkNz","inner":"FixedBottom_inner__gJvcG"};